// TermsOfService.js
// Plain content only, no page chrome — rendered inside a Modal from SignupFlow.js (this app has
// no client-side router, so there's no real URL to link a standalone page to; a modal is the
// only way to show this without navigating away from the signup form and losing what's typed).
//
// This is a reasonable starting draft, not legal advice — have an actual lawyer review this
// before it's presented to real paying customers as a binding agreement.
import { COLORS } from './theme';

const SECTION_STYLE = { marginBottom: '18px' };
const HEADING_STYLE = { margin: '0 0 6px 0', fontSize: '13px', fontWeight: '700', color: COLORS.text };
const BODY_STYLE = { margin: 0, fontSize: '13px', color: COLORS.textMuted, lineHeight: '1.6' };

function TermsOfService() {
  return (
    <div>
      <p style={{ margin: '0 0 20px 0', fontSize: '11px', color: COLORS.textFaint }}>Last updated: {new Date().toLocaleDateString()}</p>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>1. Your Account</h4>
        <p style={BODY_STYLE}>
          By creating a company account on this platform ("Service"), you confirm you have the authority to
          agree to these terms on behalf of your business. You're responsible for keeping your login
          credentials confidential and for all activity that happens under your account, including accounts
          you create for your own employees or technicians.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>2. What the Service Does</h4>
        <p style={BODY_STYLE}>
          The Service helps field-service businesses manage work orders, scheduling, customers,
          estimates, invoices, and related business operations. Features may be added, changed, or removed
          over time as the Service is developed further.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>3. Payment</h4>
        <p style={BODY_STYLE}>
          Subscription fees and payment terms are arranged directly with us outside of this signup flow.
          Continued access to your account is contingent on staying current with whatever payment
          arrangement you've agreed to. We'll make reasonable efforts to contact you before suspending
          access for non-payment.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>4. Your Data</h4>
        <p style={BODY_STYLE}>
          You own the business data you put into the Service — your customers, work orders, invoices, and
          everything else. We store it to provide the Service to you and don't sell it. See our Privacy
          Policy for more detail on how data is handled.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>5. Account Access for Support</h4>
        <p style={BODY_STYLE}>
          From time to time, authorized personnel may need to sign in to your company account as one of your
          users — for example, to troubleshoot an issue you've reported or investigate unexpected behavior.
          Every such session is logged (who accessed the account, when, and as whom) and is shown on-screen
          for as long as it's active, so your team can see it happening in real time. This access is used
          solely to provide and support the Service — never to view, use, or share your data for any other
          purpose.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>6. Acceptable Use</h4>
        <p style={BODY_STYLE}>
          Don't use the Service to store or transmit anything illegal, don't attempt to access another
          company's data or disrupt the Service for other users, and don't use it in a way that violates
          applicable law.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>7. Limitation of Liability</h4>
        <p style={BODY_STYLE}>
          The Service is provided "as is." We aren't liable for indirect, incidental, or consequential
          damages arising from your use of it, including lost business, lost data, or lost profits, to the
          fullest extent permitted by law.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>8. Cancellation</h4>
        <p style={BODY_STYLE}>
          You may stop using the Service and request account closure at any time. We'll retain your data
          for a reasonable period after cancellation in case you'd like to export it, then delete it upon
          request.
        </p>
      </div>

      <div style={SECTION_STYLE}>
        <h4 style={HEADING_STYLE}>9. Changes to These Terms</h4>
        <p style={BODY_STYLE}>
          We may update these terms from time to time. Continued use of the Service after an update means
          you accept the revised terms.
        </p>
      </div>
    </div>
  );
}

export default TermsOfService;
